import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Button,
  CheckIcon,
  CloseIcon,
  PageTitle,
  HeroLogo,
  ResendVerifyEmailButton,
  ResultContainer,
} from '../../components';
import { useVerifyEmailResult } from './hooks/useVerifyEmailResult';
import { Stack, styled, Typography } from '@mui/material';

const Container = styled(Stack)`
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const UserVerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const token = searchParams.get('token');

  const { isVerified, loading, error } = useVerifyEmailResult({ email, token });

  if (loading) {
    return (
      <ResultContainer>
        <HeroLogo />
        <PageTitle>检查中...</PageTitle>
      </ResultContainer>
    );
  }

  return (
    <ResultContainer>
      <HeroLogo />
      {isVerified && (
        <Container>
          <PageTitle>邮箱验证成功</PageTitle>
          <CheckIcon color="#1AB260" size="100px" />
          <Button variant="primary" onClick={() => navigate('/')}>
            返回首页
          </Button>
        </Container>
      )}
      {!isVerified && (
        <Container>
          <Stack alignItems="center">
            <PageTitle>邮箱验证失败</PageTitle>
            {error && (
              <Typography fontSize={14} color="textSecondary">
                {error}
              </Typography>
            )}
          </Stack>
          <CloseIcon color="#EF454A" size="100px" />
          <ResendVerifyEmailButton />
        </Container>
      )}
    </ResultContainer>
  );
};
